// Errors are logged in development only; production consoles stay clean
export const logError = (...args) => {
  if (process.env.NODE_ENV !== "production") console.error(...args);
};
